module.exports = __webpack_public_path__ + "static/img/tie.05b8dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/tie.png
// module id = Lwxe
// module chunks = 0